import App from './App.jsx'

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/index.js